import { jsx, jsxs } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { isMobile } from '@dynamic-labs/multi-wallet';
import '@dynamic-labs/sdk-api';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '../../../../context/ViewContext/ViewContext.js';
import '../../../../utils/constants/colors.js';
import { widgetModalZIndex } from '../../../../shared/consts/index.js';
import { DynamicWidgetCard } from '../DynamicWidgetCard/DynamicWidgetCard.js';
import { MemoizedDynamicWidgetHeader } from '../DynamicWidgetHeader/DynamicWidgetHeader.js';
import { DynamicWidgetPrompts } from '../DynamicWidgetPrompts/DynamicWidgetPrompts.js';
import { DynamicWidgetVariants } from '../DynamicWidgetVariants/DynamicWidgetVariants.js';
import { DynamicWidgetViews } from '../DynamicWidgetViews/DynamicWidgetViews.js';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import { ShadowDOM } from '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../config/ApiEndpoint.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import '../../../../components/IconButton/IconButton.js';
import { IsBrowser } from '../../../../components/IsBrowser/IsBrowser.js';

const DynamicUserProfile = ({ variant, }) => {
    const { projectSettings } = useInternalDynamicContext();
    const _variant = useMemo(() => {
        if (isMobile()) {
            return 'modal';
        }
        return variant;
    }, [variant]);
    if (!projectSettings)
        return null;
    return (jsx(IsBrowser, { children: jsx(DynamicWidgetVariants, Object.assign({ variant: _variant, zIndex: widgetModalZIndex }, { children: jsxs(DynamicWidgetCard, { children: [jsx(MemoizedDynamicWidgetHeader, {}), jsx(DynamicWidgetViews, {}), jsx(DynamicWidgetPrompts, {})] }) })) }));
};
const ShadowedDynamicUserProfile = () => (jsx(ShadowDOM, Object.assign({ zIndex: widgetModalZIndex }, { children: jsx(DynamicUserProfile, {}) })));

export { DynamicUserProfile, ShadowedDynamicUserProfile };
